<template>
  <v-btn v-if="integracao_rms_ativa" small color="primary" class="mr-5" @click="exportar">
    <v-icon class="mr-1" :size="18">mdi-file-export</v-icon>
    Exportação RMS
  </v-btn>
</template>

<script setup>
import $axios from "@/api/api";

const props = defineProps({
  idpedido_systock: Number,
});

const integracao_rms_ativa = localStorage.integracao_rms_drp_via_arquivo === 'S';

function exportar() {
  window.open(`${$axios.defaults.baseURL}/relatorios/integracao-erp-rms?idpedido_systock=${props.idpedido_systock}`, "_blank");
}
</script>
